<template>
  <div class="columns">
    <span class="column">{{ tagName }}</span>
    <span class="column">
      <router-link :to="{ path: '/edit-category/' + category.id}" >Edit</router-link>
    </span>
  </div>
</template>

<script>
import { firestore } from "@/firebase"
const PARENT_CATEGORIES_COLLECTION = "ParentCategories";

export default {
  props: ["category"],
  data() {
    return {
      parentCategories: []
    };
  },
  mounted() {
    firestore.collection(PARENT_CATEGORIES_COLLECTION).onSnapshot(snapshot => {
      let parentCategories = snapshot.docs.map(d => {
        var data = d.data();
        data.id = d.id;
        return data;
      });
      this.parentCategories = parentCategories;
    });
  },
  computed: {
    tagName: function() {
      if (this.parentCategories.length == 0) {
        return this.category.name;
      }
      let foundParent = this.parentCategories.find(parentCategory => {
        console.log(parentCategory);
        return parentCategory.id == this.category.parentId;
      });
      return foundParent.name + " // " + this.category.name;
    }
  }
};
</script>